module.exports = __webpack_public_path__ + "img/edi.b82ad081.png";